let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jp3gT"), load("fGT64"), load("jkPqm"), load("6aruy")]).then(() => parcelRequire('9VKkC'));